export const ActionType = {
  ADD: "Add",
  REMOVE: "Remove",
};
